import React, { useEffect } from 'react';
import "../introduction.css";
import { PiGraphBold } from "react-icons/pi";
import { FcEngineering } from "react-icons/fc";
import { IoMdDownload } from "react-icons/io";
import DevOpsResume from "./AbhinandanSaha_DevOps.pdf";
import SWEResume from "./AbhinandanSaha_SWE.pdf";

const contact = (props) => {

    return (
        <div id='me_resume'>
            <div className='container' style={{flexWrap: "wrap"}}>
                <div className='center' >
                    <div className='resume center flex_column' style={{marginRight: 0}}>
                        <div className='left center'>
                            <PiGraphBold size={100} color='lightblue'/>
                        </div>
                        <div className='centre'>
                            Download my DevOps, Cloud,Distributed Systems resume
                        </div>
                        <div className='right center'>
                            <a href={DevOpsResume} download="AbhinandanSaha_DevOps" target='_blank'>
                                <IoMdDownload size={100}/>
                            </a>
                        </div>
                    </div>
                    <div className='resume center flex_column'>
                        <div className='left center'>
                            <FcEngineering size={100}/>
                        </div>
                        <div className='centre'>
                            Download my Software Engineering, Research & Development resume
                        </div>
                        <div className='right center'>
                            <a href={SWEResume} download="AbhinandanSaha_SWE" target='_blank'>
                                <IoMdDownload size={100}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='poster_right'>
                <div className='poster'>
                    Resume
                    <div className='poster_hr' style={{backgroundColor: "#EAEAEA"}}/>
                    <div className='poster_subheading'>
                        View and download my resume. I am interested in DevOps, SWE and R&D roles and my resumes are tailored for the same.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default contact;